import { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Copy, Pencil, Check, X } from 'lucide-react';
import { toast } from 'sonner';

const EditableField = ({ field, label, value, type = 'text', isSensitive = false, customEditRenderer = null, canEdit, editingField, editingValue, setEditingValue, startEditing, confirmEdit, cancelEdit }) => {
  const isEditing = editingField === field;
  const displayValue = isSensitive && value ? '********' : (value || '-');

  const getInputHandler = (e) => {
    let val = e.target.value;
    if (field === 'companyName') val = val.toUpperCase();
    if (field === 'accountNumber') val = val.replace(/\D/g, '');
    setEditingValue(val);
  };

  const handleCopy = async (text, lbl) => {
    try { await navigator.clipboard.writeText(text); toast.success(`${lbl} copied!`); }
    catch { toast.error('Failed to copy'); }
  };

  return (
    <div className="flex items-center justify-between py-2 px-3 rounded-md hover:bg-slate-50 group" data-testid={`field-row-${field}`}>
      <div className="flex-1 min-w-0">
        <span className="text-xs text-slate-500 block">{label}</span>
        {isEditing ? (
          customEditRenderer ? (
            <div className="flex items-center gap-2 mt-1">
              {customEditRenderer(field, editingValue)}
              <Button variant="ghost" size="sm" className="h-7 w-7 p-0 text-red-500 hover:text-red-600 hover:bg-red-50" onClick={cancelEdit}><X className="w-4 h-4" /></Button>
            </div>
          ) : (
            <div className="flex items-center gap-2 mt-1">
              <Input data-testid={`edit-input-${field}`} type={type} value={editingValue}
                onChange={getInputHandler}
                onKeyDown={(e) => { if (e.key === 'Enter') confirmEdit(field); if (e.key === 'Escape') cancelEdit(); }}
                className="h-8 text-sm" autoFocus />
              <Button data-testid={`confirm-edit-${field}`} variant="ghost" size="sm" className="h-7 w-7 p-0 text-green-600 hover:text-green-700 hover:bg-green-50" onClick={() => confirmEdit(field)}><Check className="w-4 h-4" /></Button>
              <Button variant="ghost" size="sm" className="h-7 w-7 p-0 text-red-500 hover:text-red-600 hover:bg-red-50" onClick={cancelEdit}><X className="w-4 h-4" /></Button>
            </div>
          )
        ) : (
          <span className="text-sm font-medium text-slate-800 block truncate">{displayValue}</span>
        )}
      </div>
      {!isEditing && (
        <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity ml-2">
          {value && !isSensitive && <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => handleCopy(value, label)}><Copy className="w-3 h-3 text-slate-400" /></Button>}
          {canEdit && <Button data-testid={`edit-btn-${field}`} variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => startEditing(field, isSensitive ? undefined : value)}><Pencil className="w-3 h-3 text-blue-500" /></Button>}
        </div>
      )}
    </div>
  );
};

export default EditableField;
